import PropTypes from 'prop-types';
import { COLUMN_FILTER_TYPES, COLUMN_FILTER_TYPE_BY_KEY } from '../constants/columnFilterTypes';
import FilterNumericRange from './FilterNumericRange';
import FilterMultiSelect from './FilterMultiSelect';
import FilterLocation from './FilterLocation';
import KeywordCloudFilter from './KeywordCloudFilter';

/**
 * Dispatch a filter column to its editor by type. Extracted from
 * ColumnFilterPopover so the column-header popover and the Add-filter panel
 * render the exact same editors — including the keyword-cloud editor, the
 * branch the popover previously left unbuilt (its "V2" seam).
 *
 * Every editor is a controlled component with the same shape
 * `{ columnKey, value, onChange, results }`, so the host decides draft-vs-live
 * by choosing what `onChange` does. Keyword editors also take `columnFilters` +
 * `activeSpotlights` for predictive value counts (TD-2626 C).
 */
const FilterEditorSwitch = ({
  columnKey,
  value,
  onChange,
  results,
  columnFilters,
  activeSpotlights
}) => {
  switch (COLUMN_FILTER_TYPE_BY_KEY[columnKey]) {
    case COLUMN_FILTER_TYPES.NUMERIC:
      return (
        <FilterNumericRange columnKey={columnKey} value={value} onChange={onChange} results={results} />
      );
    case COLUMN_FILTER_TYPES.CONTROLLED:
      return (
        <FilterMultiSelect columnKey={columnKey} value={value} onChange={onChange} results={results} />
      );
    case COLUMN_FILTER_TYPES.LOCATION:
      return <FilterLocation value={value} onChange={onChange} results={results} />;
    case COLUMN_FILTER_TYPES.KEYWORD_CLOUD:
      return (
        <KeywordCloudFilter
          columnKey={columnKey}
          value={value}
          onChange={onChange}
          results={results}
          columnFilters={columnFilters}
          activeSpotlights={activeSpotlights}
        />
      );
    default:
      return null;
  }
};

FilterEditorSwitch.propTypes = {
  columnKey: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  results: PropTypes.array.isRequired,
  columnFilters: PropTypes.object,
  activeSpotlights: PropTypes.object
};

export default FilterEditorSwitch;
